<div class="fieldset-wrapper"
  [ngClass]="(questions?.mandatory && isMandatoryUpfront) || (questions?.mandatory && isFormSubmit && questions.isMandatoryInvalid) ? 'isMandatory' : ''">
  <span class="screen-read-only"
    *ngIf="(questions?.mandatory && isMandatoryUpfront) || (questions?.mandatory && isFormSubmit && questions.isMandatoryInvalid)">This
    Question is Required</span>
  <div *ngIf="questions?.group_no == 0 && questions?.QuestionImageAndMedia_1 != null" class="questionImageWrapper"
    [ngClass]="{'question-border': !isMobile}">
    <app-question-image-and-media [questionImageAndMedias]="questions?.QuestionImageAndMedia_1"
      [imageSize]="questions?.ImageSize" [isMobile]="isMobile">
    </app-question-image-and-media>
  </div>
  <fieldset [attr.aria-required]="isAriaRequired">
    <legend class="question-option-wrapper"
      [ngClass]="{'mobile-sub-question': isGrid, 'question-border': questions?.QuestionImageAndMedia_1 == null && !isMobile && !isGrid}">
      <span *ngIf="isPreview && (questions?.population_type == 2 || questions?.population_type == 5)"
        class="hidden-question-tooltip-icon" appTooltip [dataContext]="''" [IsButtonPanel]="false"
        IsAnswerToolTip="true" IsHiddenQToolTip="true">
      </span>
      <span *ngIf="isDisplayQno" class="question-no"><strong>{{questions?.qno}}.</strong></span>
      <span *ngIf="questions.piping && !isGrid" [ngClass]="{'question-text' : questions.isOverAllStyleApplied,
      'question-text-nb': !questions.isOverAllStyleApplied,
      'mw-sub-question-text': isGrid,'no-Qno':!isDisplayQno}" id="lbltitle_R{{questions?.UniqueNumber}}">
        <span [innerHTML]="questions?.pipingQuationTitle | headerFooterHtml"></span>
        <span *ngIf="questions.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
          [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0"></span>
          <span class="imgPostPrepop" 
          *ngIf="isEditPostPop == true && (questions?.population_type== 4 || questions?.population_type == 5)"></span>
      </span>
      <span *ngIf="!questions.piping || isGrid" [ngClass]="{'question-text' : questions.isOverAllStyleApplied,
                  'question-text-nb': !questions.isOverAllStyleApplied,
                  'mw-sub-question-text': isGrid,'no-Qno':!isDisplayQno}" id="lbltitle_R{{questions?.UniqueNumber}}">
        <span *ngIf="isDisplaySubQno; else NonDisplaySubQno" style="display: inline-block;"
          [innerHTML]="questions?.subQnoinChar| headerFooterHtml"></span>
        <ng-template #NonDisplaySubQno>
          <span style="display: none;"></span>
        </ng-template>
        <ng-container *ngIf="questions.piping && isGrid;else NormalTitle">
          <span [innerHTML]="questions?.pipingQuationTitle | headerFooterHtml"></span>
        </ng-container>
        <ng-template #NormalTitle>
          <span [innerHTML]="questions?.qtitle | headerFooterHtml"></span>
        </ng-template>
        <span *ngIf="questions.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
          [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0"></span>
          <span class="imgPostPrepop" 
          *ngIf="isEditPostPop == true && (questions?.population_type== 4 || questions?.population_type == 5)"></span>
        <div *ngIf="questions?.hasMedia && questions?.MediaText != null && questions?.MediaText != ''"
          class="question-media-text">
          <span>[{{questions?.MediaText}}]</span>
        </div>
      </span>
      <span *ngIf="isAriaRequired && (isMobile || isGrid)" class="screen-reader-only">This Question is Required</span>
    </legend>
    <div *ngIf="questions?.group_no == 0 && questions?.QuestionImageAndMedia_2 != null" class="questionImageWrapper">
      <app-question-image-and-media [questionImageAndMedias]="questions?.QuestionImageAndMedia_2"
        [imageSize]="questions?.ImageSize" [isMobile]="isMobile">
      </app-question-image-and-media>
    </div>
    <div class="fieldset-wrapper-scroll-cont">
      <div class="div-scroll-btn"><span class="div-scroll-symbol"></span></div>
      <div class="fieldset-wrapper-scroll">
        <div style="display: table; width: 100%;" class="answerParent">
          <div class="answer-option-wrapper thumb-box">
            <div *ngIf="questions?.population_type != 3; else PreReadPopulation">
              <div class="answer-option radio ld-answer-option horizontal-radio" [ngClass]="getPaletteicon(questions)">
                <div class="ld-box" [ngClass]="questions.IsDisabled?'disabled':''"
                  *ngFor="let answers of questions?.Answers; let i = index">
                  <input type="radio" [disabled]="answers?.isQuotaDisable || questions.IsDisabled"
                    (click)="clickEvent(answers)" name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_R_NAME"
                    [attr.name]="'Q'+questions?.qno+'_'+questions?.UniqueNumber+'_R_NAME'"
                    id="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_R_{{answers?.value_id}}_ID"
                    value="{{answers.value_text}}" [(ngModel)]="answers.ControlAns"
                    [attr.aria-label]="answers.value_text ? answers.value_text : 'N/A' "
                    (change)="nextQuestion($event.target)" />

                  <label for="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_R_{{answers?.value_id}}_ID"
                    [ngClass]="getPalette(questions,answers)" aria-hidden="true"></label>
                  <div *ngIf="questions?.isShowReportingVal || isGrid" class="ld-label-text"
                    [innerHTML]="answers.value_text  | headerFooterHtml"></div>

                </div>
              </div>
            </div>
            <ng-template #PreReadPopulation>
              <div class="answer-option radio ld-answer-option horizontal-radio ld-read-only"
                [ngClass]="getPaletteicon(questions)">
                <div class="ld-box" *ngFor="let answers of questions?.Answers; let i = index">
                  <div [hidden]="answers?.isHide">
                    <div [ngStyle]="{'opacity': (questions?.selectAnsValue != answers?.value_id) ? '0.3':'1'}"
                      questions>
                      <input type="radio" name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_R_NAME"
                        [attr.name]="'Q'+questions?.qno+'_'+questions?.UniqueNumber+'_R_NAME'"
                        id="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_R_{{answers?.value_id}}_ID"
                        value="{{answers.value_text}}" disabled="true" [(ngModel)]="answers.ControlAns"
                        [attr.aria-label]="answers.value_text ? answers.value_text : 'N/A' " />

                      <label for="lbl_Q{{questions?.qno}}_{{questions?.UniqueNumber}}_R_{{answers?.value_id}}_ID"
                        style="pointer-events:none;" [ngClass]="getPalette(questions,answers)"></label>
                      <div *ngIf="questions?.isShowReportingVal || isGrid" class="ld-label-text"
                        [innerHTML]="answers.value_text  | headerFooterHtml"></div>
                      <!-- <span  class="answer-text" [innerHTML]="answers.value_text | headerFooterHtml"></span> -->
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-container *ngIf="isNewParticipation  && (surveyFormat == 1 || surveyFormat == 2)">
              <div class="ques-response-btn-div" *ngIf="showNewParticipationButton">
                <!-- <input type="button" value="{{newParticipationBtnText}}" class="ques-response-btn"
                (click)="gotoNextQuestion(questions,$event.target)" /> -->
                <button *ngIf="isAnsChange" type="button" class="ques-response-btn"
                  (keyup.Space)="gotoNextQuestionKeyboard(questions,$event)"
                  (click)="gotoNextQuestion(questions,$event.target)">{{newParticipationBtnText}}</button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </fieldset>